import { render, staticRenderFns } from "./listEmpresa.vue?vue&type=template&id=52cd4e4d&scoped=true&"
import script from "./listEmpresa.vue?vue&type=script&lang=js&"
export * from "./listEmpresa.vue?vue&type=script&lang=js&"
import style0 from "./listEmpresa.vue?vue&type=style&index=0&id=52cd4e4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd4e4d",
  null
  
)

export default component.exports